import { render } from "./TrainingDetail.vue?vue&type=template&id=4aa32e51&scoped=true"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"

import "./TrainingDetail.vue?vue&type=style&index=0&id=4aa32e51&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa32e51"]])

export default __exports__